import { useCallback, useContext, useEffect, useState } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";

// import Home from "../pages/Home";
import Province from "./../../components/pages/Province";
import District from "./../../components/pages/District";
import Region from "../pages/Region";
import Candidate from "./../../components/pages/Candidate/";
import HeavyWeight from "../pages/PopularRegion/HeavyWeight";
import BattleGround from "../pages/PopularRegion/BattleGround";
import CloseMargin from "../pages/PopularRegion/CloseMargin";
import Global from "./../../components/pages/Global/";
import Party from "./../../components/pages/Parties";
import ProportionalResult from "../pages/ProportionalResult";
import NotFound from "./../../components/common/ErrorPage/NotFound";
import { Loader } from "../common/Loader";
import ScrollToTop from "../common/Util/ScrollToTop";
import LangContext from "../../contexts/LangContext";
import { ENV, API_BASE_PATH, API_URL, COMBINE_PR } from "./../../config";
import { translate } from "../../helper";

const Main = (props) => {
  const { lang } = useContext(LangContext);

  const [fetched, setFetched] = useState(false);
  const [fetchStatic, setFetchStatic] = useState(false);
  const [provinces, setProvinces] = useState([]);
  const [parties, setParties] = useState([]);
  const [result, setResult] = useState([]);
  const [resultPR, setResultPR] = useState({});
  const [candidates, setCandidates] = useState([]);
  const [searchParam, setSearchParam] = useState({ province: "", district: "", region: "" });

  const navigate = useNavigate();

  const searchhandle = useCallback((path) => navigate(path, { replace: true }), [navigate]);

  const handleSearch = (selectedValue, searchType) => {
    let newPath = "/result/";
    let searchParam = {};
    let province, district;

    switch (searchType) {
      case "province":
        newPath += selectedValue;
        searchParam.province = selectedValue;
        searchParam.district = "";
        searchParam.region = "";
        break;
      case "district":
        province = document.querySelector("#sh-search-province").value;
        if (!province) {
          for (let i = 0; i < provinces.length; i++) {
            let value = selectedValue;
            const dId = provinces[i].districts.find((d) => d.id === value);
            if (dId) {
              province = provinces[i].id;
              break;
            }
          }
        }
        if (province) {
          newPath += province + "/" + selectedValue;
        }
        searchParam.province = province || "";
        searchParam.district = selectedValue;
        searchParam.region = "";
        break;
      case "region":
        selectedValue = selectedValue.split("-")[1];
        if (!selectedValue) {
          selectedValue = "";
        }
        province = document.querySelector("#sh-search-province").value;
        district = document.querySelector("#sh-search-district").value;
        if (!province) {
          for (let i = 0; i < provinces.length; i++) {
            let prov = provinces[i];
            for (let j = 0; j < prov.districts.length; j++) {
              const rId = prov.districts[j].regions.find((r) => parseFloat(r.id).toFixed(0) === parseFloat(selectedValue).toFixed(0));
              if (rId) {
                province = prov.id;
                district = prov.districts[j].id;
                break;
              }
            }
            if (district) break;
          }
        }
        if (province && district) {
          newPath += province + "/" + district + "/" + selectedValue;
        }
        searchParam.province = province || "";
        searchParam.district = district || "";
        searchParam.region = selectedValue;
        break;
      default:
        newPath += selectedValue;
    }

    const url = new URL(window.location.href);

    url.pathname = newPath;

    setSearchParam(searchParam);

    // Only navigate if NOT on the Global page (Global is mounted on "/" and "/result")
    const currentPath = window.location.pathname;
    const isGlobalPage = currentPath === "/" || currentPath === "/result/" || currentPath === "/result";
    
    if (!isGlobalPage) {
      searchhandle(newPath + url.search);

      if (window.history.replaceState) {
        //prevents browser from storing history with each change
        window.history.replaceState({}, document.title, url);
      }
    }
  };

  const resultShaper = (provincesLight, responseData) => {
    let pData = { provinces: JSON.parse(JSON.stringify(provincesLight)) },
      fData = { provinces: JSON.parse(JSON.stringify(provincesLight)) };

    const PARTY_RANK = {
      NC: 0,
      RSP: 1,
      CPNUML: 2,
      NDP: 3,
      NKP: 4,
    };

    const getPartyRank = (code) => {
      const normalizedCode = String(code || "").toUpperCase();
      return Object.prototype.hasOwnProperty.call(PARTY_RANK, normalizedCode) ? PARTY_RANK[normalizedCode] : Number.POSITIVE_INFINITY;
    };

    const sortByPartyPriority = (rows = []) =>
      rows
        .map((row, index) => ({ row, index }))
        .sort((a, b) => {
          const rankA = getPartyRank(a.row.party);
          const rankB = getPartyRank(b.row.party);
          if (rankA !== rankB) return rankA - rankB;

          const voteA = Number(a.row.vote);
          const voteB = Number(b.row.vote);
          if (!Number.isNaN(voteA) && !Number.isNaN(voteB) && voteA !== voteB) {
            return voteB - voteA;
          }

          return a.index - b.index;
        })
        .map(({ row }) => row);

    const normalizeRegionId = (rid) => {
      const parsed = Number.parseFloat(rid);
      return Number.isNaN(parsed) ? null : parsed.toFixed(1);
    };

    const isValidCandidateRow = (row) =>
      row &&
      row.id != null &&
      row.province_id != null &&
      row.district_id != null &&
      row.region_id != null;

    const buildCandidateRow = (row) => ({
      cid: row.id,
      candidateid: row.candidateid,
      candidatephoto: row.candidatephoto,
      elected: row.elected,
      vote: row.vote,
      party: row.party_code,
      gender: row.gender,
      age: row.age,
      name_en: row.name_en,
      name_np: row.name_np,
      updated_at: row.updated_at,
    });

    responseData.forEach((cRow) => {
      if (!isValidCandidateRow(cRow)) {
        console.warn("resultShaper: invalid candidate row, skipping", cRow);
        return;
      }

      const dataRoot = cRow.rtype === "provincial" ? pData : fData;
      const provinceData = dataRoot.provinces.find((p) => String(p.id) === String(cRow.province_id));
      if (!provinceData) {
        console.warn("resultShaper: missing province for candidate row", cRow);
        return;
      }

      const districtData = provinceData.districts.find((d) => String(d.id) === String(cRow.district_id));
      if (!districtData) {
        console.warn("resultShaper: missing district for candidate row", cRow);
        return;
      }

      const regionIdNorm = normalizeRegionId(cRow.region_id);
      const regionData = districtData.regions.find(
        (r) => r.rtype === cRow.rtype && normalizeRegionId(r.id) === regionIdNorm
      );
      if (!regionData) {
        console.warn("resultShaper: missing region for candidate row", cRow);
        return;
      }

      if (!Array.isArray(regionData.result)) {
        regionData.result = [];
      }

      const candidate = buildCandidateRow(cRow);
      const existingIndex = regionData.result.findIndex((r) => String(r.cid) === String(cRow.id));

      if (existingIndex >= 0) {
        regionData.result[existingIndex] = candidate;
      } else {
        const existingSameParty = regionData.result.find(
          (r) => r.party === cRow.party_code && String(r.cid) !== String(cRow.id)
        );
        if (existingSameParty) {
          console.warn("resultShaper: duplicate party code in region", {
            province_id: cRow.province_id,
            district_id: cRow.district_id,
            region_id: cRow.region_id,
            party_code: cRow.party_code,
          });
        }
        regionData.result.push(candidate);
      }

      if (cRow.elected) {
        regionData.declared = true;
        regionData.elected = {
          cid: cRow.id,
          vote: cRow.vote,
          party: cRow.party_code,
          gender: cRow.gender,
          age: cRow.age,
          name_en: cRow.name_en,
          name_np: cRow.name_np,
          updated_at: cRow.updated_at,
        };
      }
    });

    [fData, pData].forEach((rootData) => {
      rootData.provinces.forEach((province) => {
        province.districts.forEach((district) => {
          district.regions.forEach((region) => {
            if (Array.isArray(region.result) && region.result.length > 1) {
              region.result = sortByPartyPriority(region.result);
            }
          });
        });
      });
    });

    return { federal: fData, provincial: pData };
  };

  const fetchResult = useCallback((provincesLight) => {
    fetch(API_URL + "candidate/all" + (ENV === "LOCAL_CLIENT_ONLY" ? ".json" : ""))
      .then((r) => {
        return r.json();
      })
      .then((response) => {
        const result = resultShaper(provincesLight, response.data);
        setFetched(true);
        setResult([result]);
        setCandidates(response.data);
      })
      .catch((e) => {
        console.error(e.toString());
        fetch(API_BASE_PATH + "candidate/all.json")
          .then((r) => {
            return r.json();
          })
          .then((response) => {
            const result = resultShaper(provincesLight, response.data);
            setFetched(true);
            setFetchStatic(true);
            setResult([result]);
            setCandidates(response.data);
          })
          .catch((e) => {
            setFetched(true);
            console.error(e);
          });
      });

    if (COMBINE_PR) {
      fetch(API_URL + "result/proportional" + (ENV === "LOCAL_CLIENT_ONLY" ? ".json" : ""))
        .then((r) => {
          return r.json();
        })
        .then((response) => {
          const federalData = response.data.map((d) => ({ party: d.party, vote: d.vote })).sort((a, b) => b.vote - a.vote);
          const formattedData = { federal: [{ province: 0, data: federalData }], provincial: [] };
          provincesLight.forEach((p, i) => {
            const provinceData = { province: p.id, data: response.data.map((d) => ({ party: d.party, vote: d["vote_p" + (i + 1)] })) };
            provinceData.data = provinceData.data.sort((x, y) => y.vote - x.vote);
            formattedData.provincial.push(provinceData);
          });
          setResultPR(formattedData);
        })
        .catch((e) => {
          console.error(e.toString());
          fetch(API_BASE_PATH + "result/proportional.json")
            .then((r) => {
              return r.json();
            })
            .then((response) => {
              const federalData = response.data.map((d) => ({ party: d.party, vote: d.vote })).sort((a, b) => b.vote - a.vote);
              const formattedData = { federal: [{ province: 0, data: federalData }], provincial: [] };
              provincesLight.forEach((p, i) => {
                const provinceData = { province: p.id, data: response.data.map((d) => ({ party: d.party, vote: d["vote_p" + (i + 1)] })) };
                provinceData.data = provinceData.data.sort((x, y) => y.vote - x.vote);
                formattedData.provincial.push(provinceData);
              });
              setResultPR(formattedData);
            })
            .catch((e) => {
              console.error(e);
            });
        });
    }
  }, []);

  // console.log(ENV, 'ENV')
  // console.log(candidates, 'candidates')

  useEffect(() => {
    fetch(API_URL + "region/all" + (ENV === "LOCAL_CLIENT_ONLY" ? ".json" : ""))
      .then((r) => {
        return r.json();
      })
      .then((response) => {
        setProvinces(response.data);
        fetchResult(JSON.parse(JSON.stringify(response.data)));
      })
      .catch((e) => {
        console.error(e.toString());
        fetch(API_BASE_PATH + "region/all.json")
          .then((r) => {
            return r.json();
          })
          .then((response) => {
            setProvinces(response.data);
            fetchResult(JSON.parse(JSON.stringify(response.data)));
          })
          .catch((e) => {
            console.error(e);
          });
      });

    fetch(API_URL + "party/all" + (ENV === "LOCAL_CLIENT_ONLY" ? ".json" : ""))
      .then((r) => {
        return r.json();
      })
      .then((response) => {
        setParties(response.data);
      })
      .catch((e) => {
        console.error(e.toString());
        fetch(API_BASE_PATH + "party/all.json")
          .then((r) => {
            return r.json();
          })
          .then((response) => {
            setParties(response.data);
          })
          .catch((e) => {
            console.error(e);
          });
      });
  }, [fetchResult]);

  let filteredResult = { provinces: [] };

  if (result.length > 0) {
    filteredResult = JSON.parse(JSON.stringify(result[0].federal));
    if (props.tab === "provincial") {
      filteredResult = JSON.parse(JSON.stringify(result[0].provincial));
    }
  }
  // console.log(props.tab, 'props.tab Main component')
  // console.log(fetched, 'fetched')
  // console.log(searchParam, 'searchParam')
  // console.log(provinces, 'provinces')
  // console.log(parties, 'parties')
  // console.log(filteredResult, 'filteredResult')
  // console.log(result, 'result')
  
  return (
    <>
      {fetchStatic && <div className="sh-static-note">{translate("static_data", lang)}</div>}
      {!provinces || provinces.length === 0 ? (
        <Loader />
      ) : (
        <div className="sh-container-main">
          <ScrollToTop>
            <Routes>
              <Route path="/result/:pid/" element={<Province tab={props.tab} fetched={fetched} searchParam={searchParam} provinces={provinces} parties={parties} data={filteredResult} dataPR={resultPR} handleTabChange={props.handleTabChange} handleSearch={handleSearch} />}></Route>
              <Route path="/result/:pid/:did" element={<District tab={props.tab} fetched={fetched} searchParam={searchParam} provinces={provinces} parties={parties} data={filteredResult} handleTabChange={props.handleTabChange} handleSearch={handleSearch} />}></Route>
              <Route path="/result/:pid/:did/:rid" element={<Region tab={props.tab} fetched={fetched} searchParam={searchParam} provinces={provinces} parties={parties} data={filteredResult} handleTabChange={props.handleTabChange} handleSearch={handleSearch} />}></Route>
              <Route path="/heavy-weights" element={<HeavyWeight tab={props.tab} fetched={fetched} showtab={true} showmore={false} searchParam={searchParam} provinces={provinces} parties={parties} data={filteredResult} handleTabChange={props.handleTabChange} handleSearch={handleSearch} />}></Route>
              <Route path="/battle-grounds" element={<BattleGround tab={props.tab} fetched={fetched} showtab={true} searchParam={searchParam} provinces={provinces} parties={parties} data={filteredResult} handleTabChange={props.handleTabChange} handleSearch={handleSearch} />}></Route>
              <Route path="/close-margins" element={<CloseMargin tab={props.tab} fetched={fetched} showtab={true} searchParam={searchParam} provinces={provinces} parties={parties} data={filteredResult} handleTabChange={props.handleTabChange} handleSearch={handleSearch} />}></Route>
              <Route path="/candidates/*" element={<Candidate tab={props.tab} fetched={fetched} provinces={provinces} parties={parties} candidates={candidates} handleTabChange={props.handleTabChange} />}></Route>
              <Route path="/parties" element={<Party data={parties} />}></Route>
              <Route path="/proportional/*" element={<ProportionalResult tab={props.tab} provinces={provinces} parties={parties} handleTabChange={props.handleTabChange} data={resultPR} />}></Route>
              <Route path="/result" element={<Global tab={props.tab} fetched={fetched} searchParam={searchParam} provinces={provinces} parties={parties} data={filteredResult} dataPR={resultPR} handleTabChange={props.handleTabChange} handleSearch={handleSearch} />}></Route>
              <Route path="/" element={<Global tab={props.tab} fetched={fetched} searchParam={searchParam} provinces={provinces} parties={parties} data={filteredResult} dataPR={resultPR} handleTabChange={props.handleTabChange} handleSearch={handleSearch} />}></Route>
              <Route path="*" element={<NotFound />}></Route>
              {/* <Route path="/" element={<Home fetched={fetched} parties={parties} candidates={candidates} />}></Route> */}
            </Routes>
          </ScrollToTop>
        </div>
      )}
    </>
  );
};

export default Main;
